<template>
	<div
		class="dropdown"
		:active="sActive"
		:align="align"
		:menu-type="menuType"
	>
		<div
			v-show="sActive"
			class="overlay"
			@click.stop="setActive(false)"
			@contextmenu.stop.prevent="setActive(false)"
			ref="overlay"
		></div>
		<div class="activator" ref="activator">
			<slot
				name="activator"
				:on="setActive"
				:active="sActive"
				:align="align"
			></slot>
		</div>
		<div
			class="menu-container"
			ref="menuContainer"
			:active="sActive"
			:align="align"
			:menu-type="menuType"
			:style="'top: ' + y + 'px; left: ' + x + 'px; '"
		>
			<transition name="menu-active">
				<div
					class="menu"
					v-if="eager ? true : sActive"
					v-show="eager ? sActive : true"
					ref="menu"
				>
					<slot
						v-if="$slots.content"
						name="content"
						:items="items"
						:on="setActive"
						:align="align"
					></slot>
					<template v-else>
						<slot
							v-for="(item, index) in items"
							name="item"
							:item="item"
							:index="index"
							:on="setActive"
							:align="align"
						>
							{{ item }}
						</slot>
					</template>
				</div>
			</transition>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		active: false,
		align: {
			default: 'left',
			validator(value) {
				return (
					typeof value === 'string' &&
					['left', 'right'].indexOf(value) !== -1
				);
			}
		},
		menuType: {
			default: 'list',
			validator(value) {
				return (
					typeof value === 'string' &&
					['list', 'grid'].indexOf(value) !== -1
				);
			}
		},
		eager: false,
		items: {
			default: [],
			type: Array
		}
	},
	data() {
		return {
			sActive: this.active,
			x: 0,
			y: 0
		};
	},
	methods: {
		setActive(to = !this.sActive) {
			this.sActive = to;
			this.$emit('update:active', to);
		}
	},
	watch: {
		active(newval) {
			if (newval) {
				this.$root.$app.$refs.dropdownOverlays.innerHTML = '';
				this.$root.$app.$refs.dropdownMenus.innerHTML = '';

				this.$root.$app.$refs.dropdownOverlays.appendChild(
					this.$refs.overlay
				);
				this.$root.$app.$refs.dropdownMenus.appendChild(
					this.$refs.menuContainer
				);
			}

			this.sActive = newval;
		},
		sActive(newval) {
			if (newval) {
				this.$nextTick(() => {
					let rect = this.$el.getBoundingClientRect();
					let activatorRect = this.$refs.activator.getBoundingClientRect();
					let menuRect = this.$refs.menuContainer.getBoundingClientRect();
					this.x =
						this.align === 'left'
							? rect.left
							: rect.right - menuRect.width;
					this.y = rect.y + activatorRect.height;
				});
			}
		}
	}
};
</script>
